import { useEffect, useState } from "react"
import { httpGet } from "../../../../../modules/Backend"
import { EntityNames } from "../../../../../enums/EntityNames"
import React, { useState as useReactState } from "react"
import Collapsible from "../../../../lib/Collapsible"
import { Button } from "react-aria-components"
import IconChevronUp from "../../../../../assets/icons/icon-chevron-up-blue.svg"
import IconChevronDown from "../../../../../assets/icons/icon-chevron-down-blue.svg"

interface ISidePanelPickListLocationSummary {
    recallId: string
}

export default function SidePanelRecallPickListLocationSummary({ recallId }: ISidePanelPickListLocationSummary) {
    const [data, setData] = useState<any>()
    const [canRender, setCanRender] = useState<boolean>(false);
    const [locationSummaryCollapsed, setLocationSummaryCollapsed] = useReactState<boolean>(false);

    async function getData() {
        setCanRender(false)
        const result = await httpGet(`api/${EntityNames.recalls}/locationSummary?recallId=${recallId}`);
        if (result.data) {
            setData(result.data.locations)
        }
        setCanRender(true)
    }

    useEffect(() => {
        getData()
    }, [])

    return (<>
        <div className="side-panel-table__wrapper margin__top--s margin__bottom--s">
            <div className="display--flex flex__direction--row justifyContent--space-between padding__right--xxs">
                <div className="display--flex flex__direction--row alignItems--center padding__left--xxs">
                    <p className="small">Location summary</p>
                </div>
                <Button className={"button button--with-icon alignSelf--baseline margin__right--xxs12"} onPress={() => setLocationSummaryCollapsed(prev => !prev)}>
                    <img src={`${locationSummaryCollapsed ? IconChevronDown : IconChevronUp}`}></img>
                </Button>
            </div>
            <Collapsible isCollapsed={locationSummaryCollapsed}>
                <>
                    {canRender && data ? (
                        <div className="side-panel__info-box padding__top--xs">
                            <div className="pick-list-summary__wrapper">
                                {data.map((rack: any, index: number) => (
                                    <div key={index}>
                                        <div className="pick-list-summary__rack">
                                            <div className="pick-list-summary__dot pick-list-summary__dot--primary"></div>
                                            <p className="small">{rack.breadcrumb}</p>
                                        </div>
                                        {rack.outerCubes.map((oc: any) => {
                                            const sortedPackingBoxes = [...(oc.packingBoxes || [])].sort((a: any, b: any) => 
                                                (a.sequenceNumber || 0) - (b.sequenceNumber || 0)
                                            );
                                            return (
                                                <div key={oc.name}>
                                                    <div className="pick-list-summary__outer-cube">
                                                        <div className="pick-list-summary__dot pick-list-summary__dot--accent2"></div>
                                                        <p className="small">{oc.name}</p>
                                                    </div>
                                                    {sortedPackingBoxes.map((pb: any) => (
                                                        <div key={pb.name} className="pick-list-summary__packing-box">
                                                            <div className="pick-list-summary__dot pick-list-summary__dot--accent3"></div>
                                                            <p className="small">{pb.name}</p>
                                                            {pb.sequenceNumber !== undefined && (
                                                                <p className="small small--2 margin__left--s">Seq: {pb.sequenceNumber}</p>
                                                            )}
                                                            {pb.volumeVNumber && (
                                                                <p className="small small--2 margin__left--s">{pb.volumeVNumber}</p>
                                                            )}
                                                            <p className="small small--2 margin__left--s">{pb.itemQuantity} {pb.itemQuantity === 1 ? "item" : "items"}</p>
                                                        </div>
                                                    ))}
                                                </div>
                                            );
                                        })}
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        <div className="side-panel__info-box margin__top--s">
                            <div className={`display--flex alignItems--center flex__direction--column gap--s`}>
                                <div className={`form__wrapper form__wrapper`}>
                                    <div className="loaders loaders__panel form__inline-loader"></div>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            </Collapsible>
        </div>
    </>
    )
}